module.exports = __webpack_public_path__ + "roundabout_straight.svg?45617bd0bd3eb31ef8bb6f91449da0d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_straight.svg
// module id = 222
// module chunks = 0